/* eslint-disable */
import React, { Component } from 'react';
import ConfigurationScreenNavbar from './ConfigurationScreenNavbar/ConfigurationScreenNavbar';
import ConfigurationScreenHeader from './ConfigurationScreenHeader/ConfigurationScreenHeader'
import { Redirect } from 'react-router';
import axios from 'axios';
import socket from '../../SocketManager';

import config from '../../moramma-config.json';
import Aux from '../../hoc/Aux';
import classes from './ConfigurationScreenBase.css'
import ConfigurationScreenContentPassword from './ConfigurationScreenContent/ConfigurationScreenContentPassword';
import ConfigurationScreenContentHome from './ConfigurationScreenContent/ConfigurationScreenContentHome';
import ConfigurationScreenContentPlaylist from './ConfigurationScreenContent/ConfigurationScreenContentPlaylist'
import ConfigurationScreenContentGenres from './ConfigurationScreenContent/ConfigurationScreenContentGenres/ConfigurationScreenContentGenres';
import ConfigurationScreenContentAccount from './ConfigurationScreenContent/ConfigurationScreenContentAccount/ConfigurationScreenContentAccount';
import ConfigurationScreenContentDefault from './ConfigurationScreenContent/ConfigurationScreenContentDefault';
import ConfigurationScreenContentFilters from './ConfigurationScreenContent/ConfigurationScreenContentFilters/ConfigurationScreenContentFilters';

class ConfigurationScreenBase extends Component {
  state = {
    socket : {
      signature : 'nextsong-signature'
    },
    content: 1,
    logged : true,
    language: 'IT-it',
    roomName: ''
  }
  
  selector = (id) => {
   // console.log('clicked',id)
  }

  componentWillMount() {
    const localtoken = localStorage.getItem('API');
    if(!localtoken) {
        return this.setState({ logged: false });
    }
  }

  socketPing = () => {
    socket.emit('socket-ping-keep-alive');
    setTimeout(this.socketPing, 5000);
  }

  async componentDidMount() {
    // Retrive data from API
    await this.fetchUserData();

    this.socketPing();

    console.log(`[NEXTSONG][componentDidMount() | connect] send signature '${this.state.socket.signature}'to server for validation`);
        socket.emit('react-subscribe-id', { customId: this.state.socket.signature, room: this.state.roomName});

        /** wait ack */
        // TODO: repace with jwt
        socket.on('server-ack-id-validation', () => {
            console.log('[NEXTSONG][componentDidMount() | server-ack-id-validation] receive ack validation from server');
        });

    socket.on('server-owner-data-updated', (payload) => {
      console.log('[ConfigurationScreenBase][componentDidMount() | server-owner-data-updated] receive new userdata changes', payload);

      let oldLang = this.state.language;
      oldLang = payload.owner.language;
      this.setState({ language: oldLang });
    });
  }

    logOut = () => {
      socket.emit('client-leave-channel', { customId: this.state.socket.signature, room: this.state.roomName });
      logger.debug('[ManagerScreen|logOut] Logging out ...');
      localStorage.clear();
      this.setState({ logged: false });
    }

    /**
     * @description
     * fetch user data
    */
    fetchUserData = async () => {
      const localtoken = localStorage.getItem('API');
      if (!localtoken) {
        this.logOut();
      }

      // Call 
      await axios({
        method: 'post',
        url: `${config.BASE_API}/react/user`,
        headers: {
          Authorization: `Bearer ${localtoken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        data: { token: localtoken }
      }).then(async items => {
        // Update state
        this.setState({
          language: items.data.data.owner.language,
          roomName: items.data.data.location.name
          }); 
        // warn('ok data', items.data.data);
      }).catch(err => {
        logger.error('[ManagerScreen|fetchUserData] Error during  API/react/user call', err);
        this.logOut();
      });
    };

  renderPage() {
    switch(this.props.match.params.name) {
      case 'home': return <ConfigurationScreenContentHome
                            language={this.state.language} />;
      case 'playlist': return <ConfigurationScreenContentPlaylist
      language={this.state.language} />;
      case 'genres': return <ConfigurationScreenContentGenres
      language={this.state.language} />;
      case 'filters': return <ConfigurationScreenContentFilters
      language={this.state.language} />;
      case 'account': return <ConfigurationScreenContentAccount
      language={this.state.language} />;
      default: return <ConfigurationScreenContentDefault
      language={this.state.language} />;
    }
  }

  render() {
    if (this.state.logged === false) {
      return <Redirect to="/logout" />;
    }
    
    return (
      <Aux>
        <div className="container-fluid">
          <div className="row">
            <div className={"col-sm-2 " + classes.NavCol}>
              <div className="sticky-top flex-grow-1">
                <ConfigurationScreenNavbar
                  selector={this.selector} />
              </div>
            </div>
            <div className="col" id="main">
            <ConfigurationScreenHeader />
            {this.renderPage()}
          </div>
          </div>  
        </div>
      </Aux>
    );
  }
} 

export default ConfigurationScreenBase;
